/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Trust_Refund_TitleInputs */

const en_directory_ai_tools_trust_refund_title = /** @type {(inputs: Directory_Ai_Tools_Trust_Refund_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed renders are free`)
};

const zh_directory_ai_tools_trust_refund_title = /** @type {(inputs: Directory_Ai_Tools_Trust_Refund_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成失败不扣费`)
};

/**
* | output |
* | --- |
* | "Failed renders are free" |
*
* @param {Directory_Ai_Tools_Trust_Refund_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_trust_refund_title = /** @type {((inputs?: Directory_Ai_Tools_Trust_Refund_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Trust_Refund_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_trust_refund_title(inputs)
	return zh_directory_ai_tools_trust_refund_title(inputs)
});
export { directory_ai_tools_trust_refund_title as "directory.ai_tools.trust.refund_title" }